// src/components/organisms/Profile/ProfileChallengesSection.js

import React from "react";
import { Box, Typography, Grid, Link } from "@mui/material";
import SubmissionCard from "../molecules/ChallengeSubmission/SubmissionCard";

const SubmissionsSection = ({ header, submissions, link, theme }) => {
  return (
    <Box
      sx={{
        borderRadius: "25px",
        padding: 4,
        paddingBottom: 0,
        mt: 4, // Add margin-top for spacing
      }}
    >
      {/* Full-width Row Above the Grid */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 4,
        }}
      >
        {/* Red Circle */}
        <Box
          sx={{
            width: 20,
            height: 20,
            backgroundColor: theme.colors.red,
            borderRadius: "50%",
            marginRight: 2,
          }}
        ></Box>

        {/* Vertical Line */}
        <Box
          sx={{
            width: 2,
            height: 40,
            backgroundColor: theme.colors.darkGray,
            marginRight: 2,
          }}
        ></Box>

        {/* Header and Link */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            variant="body1"
            sx={{
              fontFamily: "basic-sans",
              fontWeight: "normal",
              marginRight: 2,
              fontSize: "1.2em",
            }}
          >
            {header}
          </Typography>

          <Link
            href={link}
            underline="none"
            sx={{
              fontFamily: "basic-sans",
              fontWeight: "normal",
              marginRight: 2,
              fontSize: "1.2em",
              color: theme.colors.red,
              cursor: "pointer",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            View All
          </Link>
        </Box>
      </Box>

      {/* Grid of Submission Cards */}
      <Grid container spacing={4}>
        {submissions.map((submission) => (
          <Grid item xs={12} sm={6} md={4} key={submission.id}>
            {/* Submission Card */}
            <SubmissionCard submission={submission} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SubmissionsSection;
